// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3m3i4","left":"InfoRow_left__35ucg"};